/* eslint-disable perfectionist/sort-objects */
export const vehicleHistoryListColumns = {
	dateTime: 250,
	event: 350,
	details: 450,
	trigger: 140,
}
